// Week 6 / Day 2 — Сон, энергия, отклонения и проценты / Sleep, Energy, Deviations and Percent
// Solid Grade 6 math + RU Grade 3–4.

export const maxWeek6Day2 = {
  id: 'max-week-6-day-2',
  studentId: 'max',
  weekId: 'week-6',
  dayId: 'day-2',
  title: 'Сон, энергия, отклонения и проценты / Sleep, Energy, Deviations and Percent',
  shortTitle: 'Сон и данные / Sleep and Data',
  theme:
    'Макс анализирует сон как данные: среднее, отклонения, проценты, обратный процент. / Max analyses sleep as data: mean, deviations, percent, inverse percent.',
  estimatedTimeLabel: 'Онлайн: 25–35 мин. Полный день: 80–100 мин. / Online: 25–35 min. Full day: 80–100 min.',
  nimnyIntro:
    'Нимни показывает, как посмотреть на неделю сна не одним днём, а рядом чисел. / Nimny shows how to see a week of sleep as a series of numbers.',
  goals: [
    'Слой 1. Математика / Layer 1. Math: среднее/медиана/размах, отрицательные отклонения, процент недостачи, обратный процент (Grade 6). / mean/median/range, negative deviations, missing percent, inverse percent.',
    'Слой 2. Русский / Layer 2. Russian: части речи, безударные, исправление. / parts of speech, unstressed, correction.',
    'Слой 3. Чтение и письмо / Layer 3. Reading: короткий текст о сне и энергии + план + 3–5 предложений.',
    'Слой 4. Логика и анализ данных / Layer 4. Logic and data analysis: почему один день не показатель.',
    'Слой 5. Практика: свой sleep log на 5 дней с целью 8 ч. / Practical: 5-day sleep log with 8-hour goal.',
    'Дневник мышления / Thinking Diary.',
    'Награда нимами / Reward in nims: 3/5.'
  ],
  vocabulary: [
    { term: 'сон / sleep', definition: 'ночной отдых организма / nightly rest of the body' },
    { term: 'энергия / energy', definition: 'сила для дел в течение дня / power for daily tasks' },
    { term: 'привычка / habit', definition: 'повторяющееся действие / a repeated action' },
    { term: 'режим / routine', definition: 'порядок дел по времени / an ordered schedule' },
    { term: 'отклонение / deviation', definition: 'разница факта и цели / actual − goal' },
    { term: 'обратный процент / inverse percent', definition: 'известна часть и процент, ищем целое / finding the whole from part and percent' }
  ],
  onlineTasks: [
    { id: 'q1', type: 'math', title: 'Среднее, медиана, размах сна / Mean, median, range',
      prompt: 'Пн 8.5, Вт 7.75, Ср 8.25, Чт 7.5, Пт 8 часов. Найди среднее, медиану и размах. / Find mean, median and range.',
      helper: 'Сортируй перед медианой. / Sort for median.',
      answer: 'Среднее 8 ч; медиана 8 ч; размах 1 ч. / Mean 8; median 8; range 1.', unit: 'ч / h' },
    { id: 'q2', type: 'math', title: 'Отклонения от нормы / Deviations from goal',
      prompt: 'Цель 8 часов. Отклонения: +0.5, −0.25, +0.25, −0.5, 0. Найди общее и среднее отклонение. / Total and mean deviation from 8.',
      helper: 'Складывай положительные и отрицательные числа. / Add signed numbers.',
      answer: 'Общее 0 ч; среднее 0 ч. / Total 0; mean 0.', unit: 'ч / h' },
    { id: 'q3', type: 'math', title: 'Процент недосыпа / Missing percent',
      prompt: 'Цель за 7 дней — 56 ч; Макс спал 52.5 ч. Сколько часов не хватило и какой это процент? / How many hours missing and what percent of 56?',
      helper: '56 − 52.5, затем ÷ 56. / Subtract then divide.',
      answer: 'Не хватило 3.5 ч; 6.25%. / 3.5 hours; 6.25%.', unit: 'ч / h' },
    { id: 'q4', type: 'math', title: 'Обратный процент / Inverse percent',
      prompt: 'Макс выполнил 87.5% недельной цели сна; это 49 часов. Какая полная цель? / 87.5% = 49 hours. Find whole.',
      helper: '49 ÷ 0.875. / Divide by percent as decimal.',
      answer: '56 часов. / 56 hours.', unit: 'ч / h' },
    { id: 'q5', type: 'classify', title: 'Части речи / Parts of speech',
      prompt: 'Распредели слова по частям речи. / Sort by part of speech.',
      categories: [
        { id: 'noun', label: 'Существительное / Noun' },
        { id: 'verb', label: 'Глагол / Verb' },
        { id: 'adj', label: 'Прилагательное / Adjective' }
      ],
      items: [
        { id: 'w1', text: 'энергия / energy' },
        { id: 'w2', text: 'привычка / habit' },
        { id: 'w3', text: 'спокойный / calm' },
        { id: 'w4', text: 'восстанавливать / to restore' },
        { id: 'w5', text: 'ночной / night (adj)' },
        { id: 'w6', text: 'отдыхать / to rest' }
      ] },
    { id: 'q6', type: 'text', title: 'Исправь ошибки / Fix mistakes',
      prompt: 'Перепиши без ошибок: «сон помагает восстанавитса и завтра иметь больше энергии». / Rewrite without mistakes.',
      placeholder: 'Сон помогает... / Sleep helps...' },
    { id: 'q7', type: 'text', title: 'Главная мысль и план / Main idea and plan',
      prompt: 'Прочитай текст «Сон и энергия» на печатной странице. Запиши главную мысль, план из 3 пунктов и 4 предложения о сне. / Read the printed text; write main idea, 3-point plan and 4 sentences.',
      placeholder: 'Главная мысль: ... / Main idea: ...' },
    { id: 'q8', type: 'text', title: 'Логика: один день или неделя? / Logic: one day or a week?',
      prompt: 'Можно ли по одному дню сна сказать, что режим работает? Приведи 2 причины и пример. / Can you judge routine by one day? Give 2 reasons and an example.',
      placeholder: 'Один день... / One day...' },
    { id: 'q9', type: 'essay', title: 'Мой sleep log / My sleep log',
      prompt: 'Опиши 5 дней сна: время отбоя, подъёма и часы сна. Посчитай среднее и размах, если есть данные. / Describe 5 days of sleep: bedtime, wake-up, hours; compute mean and range.',
      minSentences: 4, maxSentences: 8, placeholder: 'Пн: отбой 22:00... / Mon: bedtime 22:00...' }
  ],
  notebookInstructions: [
    'Заголовок: «Неделя 6, День 2». / Heading.',
    'Слой 1. Математика: q1 (среднее/медиана/размах), q2 (отклонения), q3 (% недостачи), q4 (обратный %). / Math tasks.',
    'Слой 2. Русский: части речи + исправление. / Russian: parts of speech + correction.',
    'Слой 3. Чтение: главная мысль + план + 4 предложения. / Reading.',
    'Слой 4. Логика: аргумент про неделю против одного дня. / Logic.',
    'Слой 5. Практика: sleep log на 5 дней. / Practical: 5-day sleep log.',
    'Дневник мышления / Thinking diary.',
    'Награда нимами. / Reward.'
  ],
  printWorksheet: {
    title: 'Неделя 6, День 2 / Week 6, Day 2',
    subtitle: 'Сон, энергия, отклонения и проценты / Sleep, Energy, Deviations and Percent',
    pages: [
      { title: 'Маршрут дня: пять слоёв обучения / Daily route: five learning layers', blocks: [
        { type: 'list', items: [
          '1. Математика / Math — 30–35 мин / min.',
          '2. Русский язык / Russian — 15–20 мин / min.',
          '3. Чтение и письмо / Reading and writing — 10–15 мин / min.',
          '4. Логика и анализ данных / Logic and data analysis — 5–10 мин / min.',
          '5. Практика: свой sleep log / Practical: own sleep log — 10–15 мин / min.',
          '6. Дневник мышления / Thinking diary — 5 мин / min.',
          '7. Награда нимами / Reward in nims.'
        ] }
      ] },
      { title: 'Слой 1. Математика / Layer 1. Math', blocks: [
        { type: 'text', text: 'Grade 6: среднее, медиана, размах, знаковые отклонения, проценты и обратные проценты. Показывай шаги. / Show steps.' },
        { type: 'list', items: [
          '1) Сон 8.5, 7.75, 8.25, 7.5, 8 ч. Сумма = ____. Среднее = ____ ÷ 5 = ____. Сортировка: ____, ____, ____, ____, ____. Медиана = ____. Размах = ____ − ____ = ____. / Mean, median, range.',
          '2) Цель 8 ч. Отклонения +0.5, −0.25, +0.25, −0.5, 0. Сумма = ____. Среднее = ____ ÷ 5 = ____. / Signed sum.',
          '3) Цель 7 дней = 56 ч. Спал 52.5 ч. Не хватает: 56 − 52.5 = ____. Процент: ____ ÷ 56 = ____ = ____%. / Missing hours + percent.',
          '4) Часть 49 ч = 87.5% целого. Целое = 49 ÷ 0.875 = ____ ч. / Inverse percent.',
          '5) Проверка / Check: 8 × 7 = ____ ч (недельная цель). / Weekly goal check.',
          '6) Отклонения по дням от 8: 8.5 − 8, 7.75 − 8, 8.25 − 8, 7.5 − 8, 8 − 8 = ____, ____, ____, ____, ____. / Per-day deviations.',
          '7) Optional / Доп.: 6.25% от 56 = ____. / 6.25% of 56.',
          '8) Optional / Доп.: если процент выполнения 90%, а полная цель 56 ч, часть = 0.9 × 56 = ____ ч. / 90% of 56.'
        ] }
      ] },
      { title: 'Слой 2. Русский язык и правописание / Layer 2. Russian Language and Spelling', blocks: [
        { type: 'text', text: 'Правило / Rule: определяем часть речи по вопросу и роли в предложении. / Determine part of speech by question and role.' },
        { type: 'list', items: [
          'Словарь / Vocabulary: сон, энергия, привычка, режим, отдых, восстановление, отклонение, процент.',
          'Части речи / Parts of speech: энергия, привычка, спокойный, восстанавливать, ночной, отдыхать — раздели на существительные, глаголы, прилагательные.',
          'Исправь ошибки / Fix mistakes: «сон помагает восстанавитса и завтра иметь больше энергии».',
          'Мини-диктант / Mini-dictation: «Хороший сон восстанавливает силы и помогает утром чувствовать больше энергии».',
          'Орфограмма дня / Spelling rule: −тся / −ться — задай вопрос «что делает / что делать». / −тся / −ться rule.'
        ] }
      ] },
      { title: 'Слой 3. Чтение, письмо и пересказ / Layer 3. Reading, Writing and Retelling', blocks: [
        { type: 'list', items: [
          'Текст «Сон и энергия» / Text: Сон — это время, когда тело восстанавливает силы. Ночью мозг раскладывает то, что случилось днём, а мышцы отдыхают. Если сон короче или прерывистый, энергии днём меньше, и внимание слабее. Один короткий день не всегда виден сразу, а вот несколько дней подряд легко почувствовать. Поэтому лучше смотреть на неделю целиком, а не на один день. / Sleep restores strength. At night the brain sorts the day and muscles rest. Short or broken sleep lowers energy and attention. One short day is not always obvious, but several days in a row are. So look at the whole week, not one day.',
          'Главная мысль / Main idea: __________________________________',
          'План из 3 пунктов / 3-point plan: 1) ______ 2) ______ 3) ______',
          '4 своих предложения о сне и энергии / 4 sentences: ______________________________',
          'Пересказ родителю 3–5 предложений по-русски / Retell to parent in 3–5 Russian sentences ✓.'
        ] }
      ] },
      { title: 'Слой 4. Логика и анализ данных / Layer 4. Logic and Data Analysis', blocks: [
        { type: 'text', text: 'Возьми 5 дней сна из данных. / Take 5 days of sleep data.' },
        { type: 'list', items: [
          'Какой был лучший и худший день по сну? / Best and worst day for sleep?',
          'Есть ли один день, который сильно отклоняется? / Is there an outlier day?',
          'Что вероятнее говорит о режиме: один день или пять? Почему? / What reflects the routine better — one day or five? Why?',
          'Мой аргумент / My argument: __________________________________',
          'Вывод / Conclusion: один день не показатель; данные надо смотреть рядом. / One day is not a signal; look at the series.'
        ] }
      ] },
      { title: 'Слой 5. Практические знания: sleep log / Layer 5. Practical Knowledge: Sleep Log', blocks: [
        { type: 'text', text: 'Это не медицинский совет. Не отслеживай медицинские данные. / Not medical advice. No medical data.' },
        { type: 'list', items: [
          'Пн / Mon: отбой ____ подъём ____ сон ____ ч.',
          'Вт / Tue: отбой ____ подъём ____ сон ____ ч.',
          'Ср / Wed: отбой ____ подъём ____ сон ____ ч.',
          'Чт / Thu: отбой ____ подъём ____ сон ____ ч.',
          'Пт / Fri: отбой ____ подъём ____ сон ____ ч.',
          'Среднее / Mean: ____ ч. Размах / Range: ____ ч.',
          'Цель / Goal: 8 ч. Отклонение среднего от цели / Mean deviation from goal: ____ ч.'
        ] }
      ] },
      { title: 'Дневник мышления / Thinking Diary', blocks: [
        { type: 'list', items: [
          'Самое важное про сон сегодня / Most important about sleep today: ______',
          'Самое важное слово / Most important word: ______'
        ] }
      ] },
      { title: 'Родительская проверка и награда нимами / Parent check and reward in nims', blocks: [
        { type: 'list', items: [
          'Базовая награда / Base reward: 3 нима / nims ✓',
          'Бонус за обратный процент / Bonus for inverse percent: +1 ☐',
          'Бонус за понятный sleep log / Bonus for a clear sleep log: +1 ☐',
          'Итого / Total: ____ из / of 5 нимов / nims'
        ] }
      ] }
    ]
  },
  parentGuide: {
    goal:
      'Grade 6: среднее/медиана/размах {7.5, 7.75, 8, 8.25, 8.5} = 8/8/1; знаковые отклонения; 3.5 ч = 6.25%; обратный процент 49 ÷ 0.875 = 56 ч. Русский Grade 3–4: части речи, −тся/−ться. / Solid Grade 6 math + Grade 3–4 Russian.',
    mathGoal: 'q1: среднее 8, медиана 8, размах 1. q2: сумма 0, среднее 0. q3: 3.5 ч, 6.25%. q4: 56 ч. / Listed with steps.',
    russianGoal: 'Существительные: энергия, привычка. Глаголы: восстанавливать, отдыхать. Прилагательные: спокойный, ночной. / Correct parts of speech.',
    readingWritingGoal: 'Главная мысль: смотрим на неделю, а не на один день. План + 4 предложения. / Main idea + plan + 4 sentences.',
    practicalGoal: 'Sleep log 5 дней, среднее и размах посчитаны. / 5-day log with mean and range.',
    check: [
      'Q1: 8 / 8 / 1.',
      'Q2: сумма 0, среднее 0. / Sum 0; mean 0.',
      'Q3: 3.5 ч, 6.25%.',
      'Q4: 56 ч (обратный процент). / 56 h (inverse percent).',
      'Части речи разобраны. / Parts of speech sorted.',
      'Главная мысль + план + 4 предложения. / Main idea + plan + 4 sentences.',
      'Логика ряда против одного дня. / Series vs single day.',
      'Sleep log посчитан. / Sleep log computed.'
    ],
    answerKey: [
      { taskId: 'q1', answer: 'Сумма 40; среднее 8 ч; сортировка 7.5/7.75/8/8.25/8.5; медиана 8; размах 1. / Mean 8; median 8; range 1.' },
      { taskId: 'q2', answer: '0.5 − 0.25 + 0.25 − 0.5 + 0 = 0; 0 ÷ 5 = 0. / Total 0; mean 0.' },
      { taskId: 'q3', answer: '56 − 52.5 = 3.5 ч; 3.5 ÷ 56 = 0.0625 = 6.25%. / 3.5 h; 6.25%.' },
      { taskId: 'q4', answer: '87.5% = 0.875; 49 ÷ 0.875 = 56 ч. / 56 hours.' },
      { taskId: 'q5', answer: 'Существительные: энергия, привычка. Глаголы: восстанавливать, отдыхать. Прилагательные: спокойный, ночной. / Correct sorting.' },
      { taskId: 'q6', answer: 'Сон помогает восстановиться и завтра иметь больше энергии.' },
      { taskId: 'q7', answer: 'Главная мысль: смотрим на неделю целиком. План: 1) что делает сон; 2) как чувствуется недосып; 3) почему смотрим неделю. 4 предложения — открытый ответ. / Open answer.' },
      { taskId: 'q8', answer: 'Ожидается: 2 причины (один день — выброс; данные ряд показывают тренд) и пример. / 2 reasons + example.' },
      { taskId: 'q9', answer: 'Открытый ответ; 5 дней сна с временем и вычислением среднего и размаха. / Open answer.' }
    ],
    spellingCheck: 'Части речи разобраны; −тся/−ться — вопросом. / Parts of speech + −tsya rule.',
    readingCheck: 'Главная мысль ясная; план 3 пункта; 4 предложения; пересказ 3–5 предложений по-русски. / Main idea + plan + retelling.',
    notebookCheck: 'Все 5 слоёв заполнены. / All 5 layers.',
    printCheck: 'Все 8 страниц заполнены. / All 8 pages.',
    discussionPrompts: [
      'Что помогает тебе быстрее заснуть? / What helps you fall asleep faster?',
      'Как ты понимаешь, что выспался? / How do you know you slept enough?',
      'Что портит сон чаще всего? / What ruins sleep most often?',
      'Что важнее для энергии — часы сна или их регулярность? / Hours vs regularity?'
    ],
    ifEasy: 'Усложни: добавь 6-й день (7 ч) и пересчитай среднее и медиану. / Extend: add a 6th day and recompute mean and median.',
    ifDifficult: 'Оставь q1 и q3. / Keep q1 and q3.',
    tokenReward:
      'После проверки можно начислить бонусные нимы через Parent Room. Нимы — это призовые токены курса, а не оплата. / Nims are course prize tokens, not payment.'
  },
  reward: {
    unit: 'nim', unitName: 'ним', base: 3, max: 5,
    label: 'Награда за завершение / Completion reward', display: '3 нима / 3 nims',
    bonuses: [
      { id: 'inverse-percent', label: 'Бонус за обратный процент / Bonus for inverse percent', amount: 1 },
      { id: 'clean-log', label: 'Бонус за понятный sleep log / Bonus for a clear sleep log', amount: 1 }
    ]
  },
  completionRequirements: { requiredTaskIds: ['q1', 'q4', 'q7', 'q9'], allowNotebookCompletion: true },
  unlockAfter: { weekId: 'week-6', dayId: 'day-1' },
  nextLessonId: 'max-week-6-day-3'
};

export default maxWeek6Day2;
